'use client';
import React, { useState } from 'react';
import Navbar from '@/components/physio/Navbar';
import Footer from '@/components/physio/Footer';
import WhatsAppButton from '@/components/physio/WhatsAppButton';

const contactInfo = [
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" width="20" height="20">
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
      </svg>
    ),
    label: 'PHONE',
    value: '9497815224',
    sub: 'Mon–Sat, 8am–8pm',
    href: 'tel:+919497815224',
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" width="20" height="20">
        <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
      </svg>
    ),
    label: 'EMAIL',
    value: 'contactdrphysio@gmail.com',
    sub: 'We reply within 2 hours',
    href: 'mailto:contactdrphysio@gmail.com',
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" width="20" height="20">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
      </svg>
    ),
    label: 'SERVICE AREA',
    value: 'Kochi – Kerala, India',
    sub: 'Home visits across Kochi',
    href: null,
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" width="20" height="20">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
      </svg>
    ),
    label: 'AVAILABILITY',
    value: '7 Days a Week',
    sub: '8am – 8pm',
    href: null,
  },
];

const whyReasons = [
  {
    title: 'CMT Certified',
    desc: 'All therapists hold CMT certification and professional credentials.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" width="18" height="18">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z" />
      </svg>
    ),
  },
  {
    title: 'MIAP Registered',
    desc: 'Registered with the Indian Association of Physiotherapists.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" width="18" height="18">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z" />
      </svg>
    ),
  },
  {
    title: 'KAPC Registered',
    desc: 'Registered with the Kerala Association of Physiotherapy Clinics.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" width="18" height="18">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z" />
      </svg>
    ),
  },
  {
    title: '24-Hour Booking',
    desc: 'First available appointment within 24 hours, often same day.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" width="18" height="18">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
      </svg>
    ),
  },
];

const faqs = [
  {
    question: 'What areas do you cover for home visits?',
    answer: 'We currently cover Kochi and surrounding areas in Kerala, India — including Ernakulam, Kakkanad, Thrippunithura, Edappally, Aluva, and nearby localities. Contact us to confirm availability in your specific area.',
  },
  {
    question: 'How quickly can I get an appointment?',
    answer: 'Most patients receive their first home visit within 24 hours of booking. Same-day appointments are available for urgent cases. Call us directly on 9497815224 for the fastest response.',
  },
  {
    question: "Do I need a doctor's referral?",
    answer: "No referral is needed. You can book directly by calling us or sending a WhatsApp message. If your condition requires doctor involvement (e.g., post-surgery coordination), we'll liaise with your medical team on your behalf.",
  },
  {
    question: 'What certifications do your physiotherapists hold?',
    answer: 'All Dr Physio therapists are CMT Certified, MIAP Registered (Member of Indian Association of Physiotherapists), and KAPC Registered. They hold minimum BSc in Physiotherapy and carry full professional credentials.',
  },
  {
    question: 'What does the therapist bring to a home visit?',
    answer: "Your therapist arrives with a portable treatment table, resistance bands, massage tools, electrotherapy equipment (if required), and all documentation materials. You don't need to provide anything except a clear space of approximately 2m x 2m.",
  },
  {
    question: 'How many sessions will I need?',
    answer: 'This depends entirely on your condition. Acute injuries typically resolve in 4–8 sessions. Post-surgery rehabilitation usually requires 8–16 sessions. Neurological and chronic conditions may benefit from ongoing maintenance programmes. Your therapist will give you a realistic estimate after the first assessment session.',
  },
];

export default function ContactPage() {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <>
      <Navbar />
      <main>
        {/* Hero Section */}
        <section className="pt-32 pb-16 overflow-hidden" style={{ backgroundColor: 'var(--background)' }}>
          <div className="mx-auto max-w-6xl px-6">
            <div className="grid lg:grid-cols-2 gap-16 items-start">
              {/* Left: Heading */}
              <div className="space-y-6">
                <span className="service-tag">Get in Touch</span>
                <h1 className="text-hero-xl font-display font-bold" style={{ color: 'var(--foreground)' }}>
                  Book your{' '}
                  <span className="font-display italic text-gradient-teal">home visit</span>
                </h1>
                <p className="text-lg leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
                  Reach out to us via WhatsApp or call to book your appointment. Our team will match you with the right therapist within 2 hours.
                </p>
              </div>

              {/* Right: Contact Info Cards */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {contactInfo?.map((info) => (
                  <div key={info?.label} className="bento-card p-5">
                    <div className="w-9 h-9 rounded-xl flex items-center justify-center mb-3" style={{ backgroundColor: 'var(--secondary)', color: 'var(--primary)' }}>
                      {info?.icon}
                    </div>
                    <p className="text-xs font-bold uppercase tracking-widest mb-1" style={{ color: 'var(--muted-foreground)' }}>{info?.label}</p>
                    {info?.href ? (
                      <a href={info?.href} className="text-base font-bold block transition-colors hover:opacity-80" style={{ color: 'var(--foreground)' }}>
                        {info?.value}
                      </a>
                    ) : (
                      <p className="text-base font-bold" style={{ color: 'var(--foreground)' }}>{info?.value}</p>
                    )}
                    <p className="text-xs mt-0.5" style={{ color: 'var(--muted-foreground)' }}>{info?.sub}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Book Now Section */}
        <section className="section-pad" style={{ backgroundColor: 'rgba(240,244,244,0.3)' }}>
          <div className="mx-auto max-w-6xl px-6">
            <div className="grid lg:grid-cols-3 gap-10">
              {/* Booking CTA */}
              <div className="lg:col-span-2">
                <div className="bento-card p-8">
                  <h2 className="text-2xl font-display font-bold mb-2" style={{ color: 'var(--foreground)' }}>Book Your Appointment</h2>
                  <p className="text-sm mb-8" style={{ color: 'var(--muted-foreground)' }}>
                    Get in touch with us instantly via WhatsApp or give us a call. We confirm appointments within 2 hours and offer same-day visits across Kochi, Kerala.
                  </p>

                  <div className="flex flex-col sm:flex-row gap-4">
                    {/* WhatsApp Button */}
                    <a
                      href="https://wa.me/919497815224?text=Hi%2C%20I%20would%20like%20to%20book%20an%20appointment"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-center gap-3 px-8 py-4 rounded-2xl font-bold text-base transition-all duration-200 hover:opacity-90 hover:scale-[1.02]"
                      style={{ backgroundColor: '#25D366', color: '#fff' }}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                      </svg>
                      WhatsApp Us
                    </a>

                    {/* Call Button */}
                    <a
                      href="tel:+919497815224"
                      className="flex items-center justify-center gap-3 px-8 py-4 rounded-2xl font-bold text-base transition-all duration-200 hover:opacity-90 hover:scale-[1.02]"
                      style={{ backgroundColor: 'var(--primary)', color: '#fff' }}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" width="22" height="22">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
                      </svg>
                      Call +91 9497815224
                    </a>
                  </div>

                  <p className="text-xs mt-6" style={{ color: 'var(--muted-foreground)' }}>
                    Available Mon–Sat, 8am–8pm · Same-day appointments available · No referral needed
                  </p>
                </div>
              </div>

              {/* Sidebar: Why Choose Us */}
              <div className="space-y-4">
                <h3 className="text-lg font-display font-bold" style={{ color: 'var(--foreground)' }}>Why Choose Dr Physio?</h3>
                {whyReasons?.map((reason) => (
                  <div key={reason?.title} className="flex items-start gap-3">
                    <div className="w-8 h-8 rounded-lg flex items-center justify-center shrink-0 mt-0.5" style={{ backgroundColor: 'var(--secondary)', color: 'var(--primary)' }}>
                      {reason?.icon}
                    </div>
                    <div>
                      <p className="text-sm font-bold" style={{ color: 'var(--foreground)' }}>{reason?.title}</p>
                      <p className="text-xs mt-0.5" style={{ color: 'var(--muted-foreground)' }}>{reason?.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="section-pad" style={{ backgroundColor: 'var(--background)' }}>
          <div className="mx-auto max-w-3xl px-6">
            <div className="text-center mb-12">
              <span className="service-tag">FAQ</span>
              <h2 className="text-section-xl font-display font-bold mt-4" style={{ color: 'var(--foreground)' }}>
                Common questions
              </h2>
            </div>
            <div className="space-y-3">
              {faqs?.map((faq, i) => (
                <div key={i} className="bento-card overflow-hidden">
                  <button
                    className="w-full flex items-center justify-between gap-4 text-left py-1"
                    onClick={() => setOpenFaq(openFaq === i ? -1 : i)}
                  >
                    <span className="text-sm font-bold" style={{ color: 'var(--foreground)' }}>{faq?.question}</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                      width="16"
                      height="16"
                      className={`shrink-0 transition-transform duration-200 ${openFaq === i ? 'rotate-180' : ''}`}
                      style={{ color: 'var(--primary)' }}
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                    </svg>
                  </button>
                  {openFaq === i && (
                    <p className="text-sm mt-3 pt-3 leading-relaxed" style={{ color: 'var(--muted-foreground)', borderTop: '1px solid var(--border)' }}>
                      {faq?.answer}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  );
}
